import _ from 'lodash'

export default variables => {
  let result = _.assignIn({}, variables)
  return result
}
